import React from "react";
import ContactForm from "@/components/ContactForm";

export default function CityContactSidebar({ cityName, slug }) {
  return (
    <aside className="lg:col-span-4 space-y-4">
      <div className="bg-white p-6 rounded border border-gray-200 lg:sticky lg:top-24">
        <h3 className="font-display tracking-widest uppercase text-base mb-3">Request a Consultation in {cityName}</h3>
        <ContactForm variant="compact" source_page={`service-area:${slug}`} showContactMethod={false} />
      </div>
    </aside>
  );
}
